module.exports = __webpack_public_path__ + "static/media/visualizacion-logo-caracol-tv-1981-1983@3x.266124fc.png";